import * as R from 'ramda'
const specJson = require('../../spec/spec' + process.env.VUE_APP_YEAR + '.json');

export const cources = R.keys(specJson.models) // ['Y11', 'Y12', 'Y21', 'Y22', 'Y23', 'Y24', 'Y25', 'Y6', 'Y7', 'special', 'basic']
// basic,special,YBA,YBB,YBC,YBD,YBE,YBF,YBG,YBH,YBJ,YBK,YBL,YBN,YBP,YBQ
export const requiredType = ['must', 'select', 'free']

const createSpecAccessPaths = () => {
  var paths = []
  R.forEach(cource => {
    R.forEach(type => {
      paths.push(R.pair(cource, type))
    }, requiredType)
  },cources)
  return paths
}

export const setupSpecList = (specJson) => {
  var specs = []
  R.forEach(paths => {
    specs.push({cource: paths[0], requiredType: paths[1], ...(R.path(paths, specJson.models))})
  }, createSpecAccessPaths())
  return specs
}

export const getMyCources = (bangouString) => {
  var resultArray = ['special', 'basic']
  for(let i = 0; i < cources.length; i++ ) {
    if (bangouString.indexOf(cources[i]) === 0) {
      resultArray.unshift(cources[i])
      return resultArray
    }
  }
  return resultArray
  
}